export const iconFontAwesomeEmojiFaceGrinWide = (
	<i className="fa-solid fa-face-grin-wide"></i>
);
